/** Shared client catalog constants (aligned with Admin `clients` table). */

export const GLOBAL_MARKET_CODE = 'Global';

/** Nullable CHECK on `clients.industry` — keep in sync with Admin. */
export const CLIENT_INDUSTRIES = [
  'Health',
  'Mega Clients',
  'Packaged goods',
  'Financial',
  'Entertainment / Media',
  'Fashion Retail',
  'Fashion Luxury',
  'Automotive',
  'Government / Public Sector',
  'Travel & Hospitality',
  'Alcohol & Beverage',
  'Restaurant / Foodservice',
  'Retail (Non-Fashion)',
  'Technology / Platforms',
  'B2B',
  'Insurance',
  'Consumer products',
  'Utilities & Energy',
  'Charity / Non-Profit',
] as const;

export type ClientIndustry = (typeof CLIENT_INDUSTRIES)[number];

/** Normalize market_code for Postgres: empty/null → Global; country codes uppercase. */
export function normalizeMarketCode(code: string | null | undefined): string {
  const trimmed = (code || '').trim();
  if (!trimmed || trimmed.toLowerCase() === 'global') return GLOBAL_MARKET_CODE;
  return trimmed.toUpperCase();
}
